import { render, staticRenderFns } from "./RegistroComprobantes.vue?vue&type=template&id=089a0bc2&scoped=true"
import script from "./RegistroComprobantes.vue?vue&type=script&lang=js"
export * from "./RegistroComprobantes.vue?vue&type=script&lang=js"
import style0 from "./RegistroComprobantes.vue?vue&type=style&index=0&id=089a0bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a0bc2",
  null
  
)

export default component.exports